import { observer } from 'mobx-react-lite';
import * as React from 'react';
import loc from 'owa-localize';
import { addOptionalAttendee } from 'owa-locstrings/lib/strings/addoptionalattendee.locstring.json';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import { ActionButton, IButtonStyles } from '@fluentui/react/lib/Button';
import { optionalAttendeesPickerPlaceHolder } from './AttendeeRows.locstring.json';
import { isFeatureEnabled } from 'owa-feature-flags';
import classnamesBind from 'classnames/bind';
const classNames = classnamesBind.bind(styles);

import styles from './AttendeeRow.scss';

export interface OptionalButtonProps {
    buttonStyle?: IButtonStyles;
    onClick?: () => void;
}

const OptionalButton: React.FunctionComponent<OptionalButtonProps> = props => {
    const { buttonStyle, onClick } = props;

    const [isTooltipVisible, setIsTooltipVisible] = React.useState<boolean>(false);
    const showCardLayout = isFeatureEnabled('mon-cal-showEditPaneInCards');

    return (
        <TooltipHost
            content={loc(addOptionalAttendee)}
            onTooltipToggle={setIsTooltipVisible}
            id="attendeeWellOptionalButton">
            <ActionButton
                className={classNames(styles.optionalAttendeeButton, {
                    showCardLayout: showCardLayout,
                })}
                styles={buttonStyle}
                onClick={onClick}
                aria-labelledby={isTooltipVisible ? 'attendeeWellOptionalButton' : undefined}>
                {loc(optionalAttendeesPickerPlaceHolder)}
            </ActionButton>
        </TooltipHost>
    );
};

export default observer(OptionalButton);
